// Legacy hockey-era static redirect table was removed. CategoryView now
// handles stale single-slug links by looking up the canonical hierarchical
// URL in the DB and redirecting. This component is kept as a no-op so
// existing route wiring still mounts something.
export const RedirectHandler = () => null;

